import React from 'react';
import {Grid, Typography} from "@mui/material";
import Room from "../SelectRoom/Room";
import * as PropTypes from "prop-types";
import ComplimentaryActivity from "./ComplimentaryActivity";
import Itinerary from "../Summary/Itinerary";
import ExtraActivity from "./ExtraActivity";

const Confirmation = ({booking}) => {
    return (
        <div>
            <Typography variant="h3" component="h3">
                Your booking confirmation number is {booking['Confirmation']} <br/><br/><br/>
            </Typography>
        </div>
    );
};

export default Confirmation;